/* Imports */
import React from "react"
import { CodeContainer } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const CodeContainerPage = () => {
    const items = [
        {
            content: (
                <CodeContainer>
                    {'const unslugify = str => {\n    return capitalize(str.replaceAll("-", " "))\n}'}
                </CodeContainer>
            ),
            code: '<CodeContainer>\n    {\'const unslugify = str => {\\n    return capitalize(str.replaceAll("-", " "))\\n}\'}\n</CodeContainer>',
        },
    ]

    return <ComponentPage items={items} />
}

export default CodeContainerPage
